import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");

// Prerendered pages carry head tags captured at build time (React-19-hoisted
// meta/title plus injected analytics nodes), all marked data-prerendered.
// React 19 document-level hydration only adopts react-dom/server output, so
// hydrateRoot on these client-rendered snapshots throws error #418 and
// duplicates every head tag. Instead: drop the captured head tags and mount
// fresh — the DOM swap is identical to React's own mismatch recovery, minus
// the error and the duplicates. The bootstrap data (window.__RIHAI_BOOTSTRAP__)
// keeps the first render immediate, so there is no skeleton flash.
document.querySelectorAll("head [data-prerendered]").forEach((n) => n.remove());
ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
